<template>
  <d-container fluid class="px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Wizyty</span>
        <h3 class="page-title">Lista wizyt</h3>
        <div class="header__title">
          <d-button class="header__title_button" @click="dateDown" theme="light">
            <i class="material-icons">keyboard_arrow_left</i>
          </d-button>
          <p class="header__title_text" :class="[dayNames[0].name === currentDay ? ( currentDay.slice(9) !== 'Niedziela' ? 'header__title_text_active' : '') : '', day === 'niedziela' ? 'header__title_text_active' : '']">
            {{dayNames[0].name}}
          </p>
          <d-button class="header__title_button" @click="dateUp" theme="light">
            <i class="material-icons">keyboard_arrow_right</i>
          </d-button>
        </div>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end rdw-grid">
        <d-button
          :theme="'dark'"
          :outline="!changeView"
          @click.prevent="buttonChangeView">
          <i class="material-icons">{{!changeView ? 'apps' : 'menu'}}</i>
          <span class="ml-3">{{!changeView ? 'Zobacz specjalistów' : 'Pokaż listę wizyt'}}</span>
        </d-button>
        <d-button
          theme="danger"
          class="ml-2"
          @click.prevent="getCurrentDate">
          <i class="material-icons">double_arrow</i>
          Zobacz dziś
        </d-button>
        <d-button
          v-if="(userData.role !== 'R_USER' && userData.role !== 'R_COORDINATOR') || userData.add_visits === 1"
          theme="success"
          class="ml-2"
          @click.prevent="$router.push('/wizyty/dodaj')">
          <i class="material-icons">add</i>
          Dodaj wizytę
        </d-button>
      </d-col>
    </d-row>
    <d-button-group class="mb-3 buttons__group">
      <d-button outline :theme="'light'" :title="'Poprzedni rok'" @click="currentDate.year -= 1"><i class="material-icons">keyboard_arrow_left</i></d-button>
      <d-button :theme="currentDate.month === 1 ? 'info': 'light'" @click="currentDate.month = 1"  class="buttons__group_month">
        <span>Styczeń</span>
        <p>{{currentDate.year}}</p>
      </d-button>
      <d-button :theme="currentDate.month === 2 ? 'info': 'light'" @click="currentDate.month = 2"  class="buttons__group_month">
        <span>Luty</span>
        <p>{{currentDate.year}}</p>
      </d-button>
      <d-button :theme="currentDate.month === 3 ? 'info': 'light'" @click="currentDate.month = 3"  class="buttons__group_month">
        <span>Marzec</span>
        <p>{{currentDate.year}}</p>
      </d-button>
      <d-button :theme="currentDate.month === 4 ? 'info': 'light'" @click="currentDate.month = 4"  class="buttons__group_month">
        <span>Kwiecień</span>
        <p>{{currentDate.year}}</p>
      </d-button>
      <d-button :theme="currentDate.month === 5 ? 'info': 'light'" @click="currentDate.month = 5"  class="buttons__group_month">
        <span>Maj</span>
        <p>{{currentDate.year}}</p>
      </d-button>
      <d-button :theme="currentDate.month === 6 ? 'info': 'light'" @click="currentDate.month = 6"  class="buttons__group_month">
        <span>Czerwiec</span>
        <p>{{currentDate.year}}</p>
      </d-button>
      <d-button :theme="currentDate.month === 7 ? 'info': 'light'" @click="currentDate.month = 7"  class="buttons__group_month">
        <span>Lipiec</span>
        <p>{{currentDate.year}}</p>
      </d-button>
      <d-button :theme="currentDate.month === 8 ? 'info': 'light'" @click="currentDate.month = 8"  class="buttons__group_month">
        <span>Sierpień</span>
        <p>{{currentDate.year}}</p>
      </d-button>
      <d-button :theme="currentDate.month === 9 ? 'info': 'light'" @click="currentDate.month = 9"  class="buttons__group_month">
        <span>Wrzesień</span>
        <p>{{currentDate.year}}</p>
      </d-button>
      <d-button :theme="currentDate.month === 10 ? 'info': 'light'" @click="currentDate.month = 10" class="buttons__group_month">
        <span>Październik</span>
        <p>{{currentDate.year}}</p>
      </d-button>
      <d-button :theme="currentDate.month === 11 ? 'info': 'light'" @click="currentDate.month = 11" class="buttons__group_month">
        <span>Listopad</span>
        <p>{{currentDate.year}}</p>
      </d-button>
      <d-button :theme="currentDate.month === 12 ? 'info': 'light'" @click="currentDate.month = 12" class="buttons__group_month">
        <span>Grudzień</span>
        <p>{{currentDate.year}}</p>
      </d-button>
      <d-button outline :theme="'light'" :title="'Następny rok'" @click="currentDate.year += 1"><i class="material-icons">keyboard_arrow_right</i></d-button>
    </d-button-group>
    <d-row
      style="width: 100%;"
      class="d-flex ml-0 mb-3 page-filters">
      <validation-observer
        ref="visits-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <div v-if="!changeView" :class="{ 'form-control ml-2': true, 'is-select': true }">
          <filter-select
            :key="selectKeyInstitutionsFalse"
            v-if="!changeView"
            v-model="filters.institution_id"
            style="width: 100%;"
            :endpoint-items="'/institutions/items'"
            :data-id="filters.institution_id"
            :reduce="obj => obj.id"
            :endpoint-item="'/institutions/item/'"
            :placeholder="'Wybierz placówkę...'"
          />
        </div>
        <div v-if="changeView" :class="{ 'form-control': true, 'is-select': true }">
          <filter-select
            :key="selectKeyInstitutionsTrue"
            v-if="changeView"
            v-model="filters.institution_id"
            style="width: 100%;"
            @input="validateFiltersForm"
            :endpoint-items="'/institutions/items'"
            :data-id="filters.institution_id"
            :reduce="obj => obj.id"
            :endpoint-item="'/institutions/item/'"
            :placeholder="'Wybierz placówkę...'"
          />
        </div>
        <div v-if="!changeView && userData.role !== 'R_USER' && userData.role !== 'R_COORDINATOR'" :class="{ 'form-control ml-2': true, 'is-select': true }">
          <filter-select
            :key="selectKeyInstitutionsTrue"
            v-if="!changeView && userData.role !== 'R_USER' && userData.role !== 'R_COORDINATOR'"
            v-model="filters.user_id"
            style="width: 100%;"
            :endpoint-items="'/users/items'"
            :data-id="filters.user_id"
            :reduce="obj => obj.id"
            :endpoint-item="'/users/item/'"
            :placeholder="'Wybierz specjalistę...'"
          />
        </div>
        <div  v-if="!changeView" :class="{ 'form-control ml-2': true, 'is-select': true }">
          <filter-select
            :key="selectKeyServices"
            v-if="!changeView"
            v-model="filters.service_id"
            style="width: 100%;"
            :endpoint-items="'/services/items'"
            :data-id="filters.service_id"
            :reduce="obj => obj.id"
            :endpoint-item="'/services/item/'"
            :placeholder="'Wybierz usługę...'"
          />
        </div>
        <d-button
          v-if="!changeView"
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>
        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>
    <div style="display: flex; width: 101%;">
      <d-card style="width: 100%;">
        <table v-if="changeView && filters.institution_id !== ''" class="table mt-0 mb-0 full-width">
          <template>
            <div class="spinner-load" v-if="spinnerSchedule">
              <div class="spinner-border spinner-border-sm decision-spinner" role="status"></div>
            </div>
          </template>
          <visits-schedule
            :key="scheduleKey"
            v-if="!spinnerSchedule"
            :time-ground="['07:00', '21:00']"
            :users-list="usersList"
            :users-list-all="usersAllList"
            :task-detail="dateList"
            :task-detail-all-free="dateAllListFree"
            :task-detail-free="dateListFree"
            :task-detail-all="dateAllList"
            :spinner-schedule="spinnerSchedule"
            :patients="patientName"
            :key-popup="componentKeyPopup"
            :day-name="dayNames[0].name"
            :refresh="refreshData"
            :patients-all="patientAllName"
            :current-day="startDate"
            :my-account="userData"/>
        </table>
        <table v-if="changeView && filters.institution_id === ''" class="table mt-0 mb-0 full-width">
          <d-alert
            class="mt-3 text-center emptyDay"
            show
            :theme="'danger'">
            <div class="mb-3 mt-2">Wybierz placówkę aby otrzymać listę pracowników</div>
          </d-alert>
        </table>
        <div v-if="!changeView" class="table mt-0 mb-0 full-width">
          <div v-if="loaded">
            <template>
              <div class="spinner-load" v-if="spinnerSchedule">
                <div class="spinner-border spinner-border-sm decision-spinner" role="status"></div>
              </div>
            </template>
            <div v-if="!spinnerSchedule">
              <div
                class="visits__box visits__box_content"
                style="width: auto;"
                v-for="(visit, i) in visits"
                :value="startDate === visit.date_start.slice(0, 10) ? empty = true : empty = false"
                v-if="startDate === visit.date_start.slice(0, 10) && !!checkbox"
                :key="'visits-' + i">
                <div class="visits__box visits__box_content_block">
                <div class="visits__box_content_block_visit">
                    <span>{{visit.date_start.slice(10, 13)}}</span>
                    <span>{{visit.date_start.slice(14, 16)}}</span>
                </div>
                  <div
                    class="visits__box_content_block_patient"
                  >
                    <div v-if="visit.service_type !== 'T_OUTSIDE' && visit.service_type !== 'T_WITHOUT_PATIENT'" class="visits__box_content_block_patient_head">
                      <i v-if="visit.patient_not_present === 1" :title="visit.patient_present_message" class="material-icons pt-2 text-danger" style="font-size: 1rem; cursor: pointer">report_problem</i>
                      Pacjent:</div>
                    <p v-if="visit.service_type !== 'T_OUTSIDE' && visit.service_type !== 'T_WITHOUT_PATIENT'" class="visits__box_content_block_patient_name" style="max-width: 10rem;">
                      {{visit.patientData.name + ' ' + visit.patientData.last_name}}
                    </p>
                    <p v-if="visit.service_type === 'T_OUTSIDE'" class="visits__box_content_block_patient_name text-danger" style="max-width: 10rem; margin-top: 0.6rem">
                      {{visit.service_type_name}}
                    </p>
                    <p v-if="visit.service_type === 'T_WITHOUT_PATIENT'" class="visits__box_content_block_patient_name text-primary" style="max-width: 10rem; margin-top: 0.6rem">
                      {{visit.service_type_name}}
                    </p>
                  </div>
                  <div
                    class="visits__box_content_block_tabs"
                  >
                    <p class="visits__box_content_block_tabs_doc" v-d-tooltip="'Specjalista:  ' + visit.userData.name + ' ' +  visit.userData.last_name">
                      <span>{{visit.userData.name.slice(0, 1)}}{{visit.userData.last_name.slice(0, 1)}}</span>
                    </p>
                  </div>
                  <div
                    class="visits__box_content_block_tabs"
                  >
                    <p style="text-align: center; max-width: 10rem;">Liczba badań: {{ visit.medical_examinations.length }}
                      <span
                        v-if="visit.medical_examinations.length > 0"
                        class="tooltip-wrapper"
                      >
                      ⓘ
                      <span class="tooltip-content">
                        <span class="tooltip-row" v-for="(exam, index) in visit.medical_examinations" :key="index">
                          {{ exam.name + ' - ' + new Date(exam.created_at).toLocaleString('pl-PL') }}
                        </span>
                      </span>
                    </span>
                    </p>
                  </div>
                  <div
                    class="visits__box_content_block_tabs"
                  >
                    <div class="visits__box_content_block_tabs_head">Poradnia:</div>
                    <p class="visits__box_content_block_tabs_name" style="max-width: 10rem;">{{visit.institutionData.name}}</p>
                    <p class="visits__box_content_block_tabs_rwd">
                      <i v-d-tooltip="'Poradnia: ' + visit.institutionData.name" class="material-icons visitListIcon">home_work</i>
                    </p>
                  </div>
                  <div
                    class="visits__box_content_block_tabs"
                  >
                    <div class="visits__box_content_block_tabs_head">Usługa:</div>
                    <p class="visits__box_content_block_tabs_name" style="max-width: 10rem;">{{visit.serviceData.name}}</p>
                    <p class="visits__box_content_block_tabs_rwd">
                      <i v-d-tooltip="'Usługa: ' + visit.serviceData.name" class="material-icons visitListIcon">work</i>
                    </p>
                  </div>
                  <div
                    class="visits__box_content_block_buttons"
                  >
                    <d-button
                      outline
                      theme="info"
                      :style="((userData.role === 'R_USER' || userData.role === 'R_COORDINATOR') && userData.id !== visit.userData.id) ? 'width: 155px' : ''"
                      class="mr-2"
                      @click.prevent="showModalInfo(visit)"
                      title="Podgląd">
                      <i class="material-icons">person_search</i>
                    </d-button>
                    <d-button
                      v-if="userData.role !== 'R_USER' && userData.role !== 'R_COORDINATOR'"
                      theme="primary"
                      class="mr-2"
                      @click.prevent="$router.push('/wizyty/edycja/' + visit.id)"
                      title="Edytuj">
                      <i class="material-icons">edit</i>
                    </d-button>
                    <d-button
                      v-if="(userData.role === 'R_USER' || userData.role === 'R_COORDINATOR') && userData.id === visit.userData.id"
                      theme="primary"
                      class="mr-2"
                      @click.prevent="$router.push('/wizyty/edycja/' + visit.id)"
                      title="Edytuj">
                      <i class="material-icons">edit</i>
                    </d-button>
                    <d-button
                      v-if="userData.role !== 'R_USER' && userData.role !== 'R_COORDINATOR'"
                      theme="warning"
                      style="color: #fff"
                      :disabled="removeInProgress"
                      class="mr-2"
                      @click.prevent="cancelVisit(visit.id)"
                      title="Anuluj">
                      <i class="material-icons">close</i>
                    </d-button>
                    <d-button
                      v-if="(userData.role === 'R_USER' || userData.role === 'R_COORDINATOR') && userData.id === visit.userData.id"
                      theme="warning"
                      style="color: #fff"
                      :disabled="removeInProgress"
                      class="mr-2"
                      @click.prevent="cancelVisit(visit.id)"
                      title="Anuluj">
                      <i class="material-icons">close</i>
                    </d-button>
                    <d-button
                      v-if="userData.role === 'R_ADMIN' || userData.role === 'R_DEPUTY_DIRECTOR'"
                      theme="danger"
                      :disabled="removeInProgress"
                      @click.prevent="removeVisit(visit.id)"
                      title="Usuń">
                      <i class="material-icons">delete</i>
                    </d-button>
                  </div>
                </div>
                <div
                  class="visits__box_content_buttons"
                >
                  <d-button
                    outline
                    theme="info"
                    :style="((userData.role === 'R_USER' || userData.role === 'R_COORDINATOR') && userData.id !== visit.userData.id) ? 'width: 50%' : ''"
                    class="mr-2"
                    @click.prevent="showModalInfo(visit)"
                    title="Podgląd">
                    <i class="material-icons">person_search</i>
                  </d-button>
                  <d-button
                    v-if="userData.role !== 'R_USER' && userData.role !== 'R_COORDINATOR'"
                    theme="primary"
                    class="mr-2"
                    @click.prevent="$router.push('/wizyty/edycja/' + visit.id)"
                    title="Edytuj">
                    <i class="material-icons">edit</i>
                  </d-button>
                  <d-button
                    v-if="(userData.role === 'R_USER' || userData.role === 'R_COORDINATOR') && userData.id === visit.userData.id"
                    theme="primary"
                    class="mr-2"
                    @click.prevent="$router.push('/wizyty/edycja/' + visit.id)"
                    title="Edytuj">
                    <i class="material-icons">edit</i>
                  </d-button>
                  <d-button
                    v-if="userData.role !== 'R_USER' && userData.role !== 'R_COORDINATOR'"
                    theme="warning"
                    style="color: #fff"
                    :disabled="removeInProgress"
                    class="mr-2"
                    @click.prevent="cancelVisit(visit.id)"
                    title="Anuluj">
                    <i class="material-icons">close</i>
                  </d-button>
                  <d-button
                    v-if="(userData.role === 'R_USER' || userData.role === 'R_COORDINATOR') && userData.id === visit.userData.id"
                    theme="warning"
                    style="color: #fff"
                    :disabled="removeInProgress"
                    class="mr-2"
                    @click.prevent="cancelVisit(visit.id)"
                    title="Anuluj">
                    <i class="material-icons">close</i>
                  </d-button>
                  <d-button
                    v-if="userData.role === 'R_ADMIN' || userData.role === 'R_DEPUTY_DIRECTOR'"
                    theme="danger"
                    :disabled="removeInProgress"
                    @click.prevent="removeVisit(visit.id)"
                    title="Usuń">
                    <i class="material-icons">delete</i>
                  </d-button>
                </div>
              </div>
              <div v-if="visits.length !== 0">
                <d-alert
                  v-for="(visit, i) in visits"
                  :key="'visits-' + i"
                  class="mt-3 text-center emptyDay"
                  v-if="day !== 'niedziela' && (startDate !== visit.date_start.slice(0, 10)) && checkbox && i && empty !== true"
                  show
                  :theme="'info'">
                  Brak dostępnych wizyt na dzień: <b>{{startDate}}</b>
                </d-alert>
              </div>
              <div v-if="visits.length === 0">
                <d-alert
                  class="mt-3 text-center emptyDay"
                  show
                  :theme="'info'">
                  <div class="mb-3" v-if="(userData.role !== 'R_USER' && userData.role !== 'R_COORDINATOR') || userData.add_visits === 1">Brak dostępnych wizyt</div>
                  <span v-if="(userData.role === 'R_USER' || userData.role === 'R_COORDINATOR') && userData.add_visits === 0">Brak dostępnych wizyt</span>
                  <d-button
                    v-if="(userData.role !== 'R_USER' && userData.role !== 'R_COORDINATOR') || userData.add_visits === 1"
                    theme="light"
                    class="ml-2 p-3 pl-4 pr-4"
                    @click.prevent="$router.push('/wizyty/dodaj')">
                    <i class="material-icons">add</i>
                    Dodaj wizytę
                  </d-button>
                </d-alert>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!loaded" class="pb-3 pt-3 text-center">
          Trwa ładowanie danych&hellip;
        </div>
        <d-alert
          v-if="loadError"
          show
          theme="warning">
          Wczytywanie danych nie powiodło się. <a hresf="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
        </d-alert>
      </d-card>
      <visits-popup
        v-if="showModalVisit"
        :key="componentKeyPopup"
        :close-modal="handleCloseInfo"
        :show-modal="showModalVisit"
        :visit="visit"
        :get-day="dayNames[0].name"
        :reload-data="refreshData"
        :my-account="userData"/>
        <div style="display: block">
        <visits-calendar
          :current-month="currentMonthDays"
          :date="currentDate"
          :date-name="dayNames"
          :first-month-day="firstMonthDay"
          :month="month"
          :prev-month="prevMonthDays"
          :prev-month-days="prevMonth"
          :weekday-name="weekDayNames"
          :weekdays="weekdays"/>
      </div>
    </div>
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import HasFilters from '../../mixins/HasFilters.vue';
import CalendarUtils from '../../utils/CalendarUtils';
import ListUtils from './../../utils/ListUtils.js';
import Pagination from '../../components/common/Pagination.vue';
import visitHoursList from '../../data/visit-hours-list';
import VisitsFilters from './VisitsFilter';
import FormUtils from './../../utils/FormUtils.js';
import VisitsPopup from './VisitsPopup';
import VisitsCalendar from './VisitsCalendar';
import VisitsSchedule from './VisitsSchedule';
import FilterSelect from '@/components/others/FilterSelect';

const moment = require('moment');

export default {
  name: 'visits',
  mixins: [
    HasFilters
  ],
  components: {
    FilterSelect,
    VisitsCalendar,
    VisitsSchedule,
    VisitsPopup,
    'pagination': Pagination,
    VisitsFilters,
  },
  data() {
    return {
      empty: false,
      checkbox: true,
      visits: [],
      visit: [],
      users: [],
      patients: [],
      usersList: [],
      usersAllList: [],
      patientName: [],
      patientAllName: [],
      usersFilter: [],
      dateList: [],
      dateAllList: [],
      dateAllListFree: [],
      dateListFree: [],
      usersDate: [],
      loadingData: true,
      loaded: false,
      loadError: false,
      removeInProgress: false,
      showModalVisit: false,
      changeView: false,
      showModal: false,
      closeModal: false,
      spinnerSchedule: false,
      dateContext: moment(),
      modalAdd: [],
      visitsList: [],
      filtersInstitution: '',
      filters: {
        search: '',
        user_id: '',
        institution_id: '',
        service_id: ''
      },
      weekdays: ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'Nd'],
      weekDayNames: ['Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota', 'Niedziela'],
      month: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień', '', ''],
      monthShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru', '', ''],
      monthNumber: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '', ''],
      dayNumber: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '', ''],
      firstDayPrev: '',
      dayPrev: '',
      day: '',
      componentKeyPopup: 0,
      selectKeyInstitutionsFalse: 0,
      selectKeyInstitutionsTrue: 0,
      selectKeyServices: 0,
      scheduleKey: 0,
      currentDate: {
        date: 0,
        month: 0,
        year: 0,
        yearAdd: 0
      },
      currentDateCopyDate: '',
      daysCount: 1
    };
  },
  mounted () {
    this.loadFilteredData();
    // this.getPatientsList();
    this.getUser();
  },
  created () {
    this.getCurrentDate();
    this.getFirstDay();
  },
  watch: {
    startDate() {
      if (this.changeView === true) {
        this.usersList = [];
        this.spinnerSchedule = true;
        this.getUsersDate();
      }
      if (this.changeView === false) {
        this.loadFilteredData();
      }
    },
    showModalVisit() {
      this.componentKeyPopup += 1
    },
    'currentDate.yearAdd': function () {
      this.firstDayInLastMonth();
      this.checkTheMonthNumber();
      this.checkSundays();
      this.getFirstDay();
    },
    'currentDate.date': function () {
      this.checkTheMonthNumber();
      this.checkSundays();
      this.alertEmpty();
    },
    'filters.institution_id': function () {
      if (this.changeView === true) {
        this.usersDate = [];
        this.dateListFree = [];
        this.dateList = [];
        this.usersList = [];
        this.patientName = [];
        this.dateAllListFree = [];
        this.dateAllList = [];
        this.usersAllList = [];
        this.patientAllName = [];
        if (this.userData.role === 'R_ADMIN' || this.userData.role === 'R_DEPUTY_DIRECTOR' || this.userData.role === 'R_RECEPTION') {
          this.spinnerSchedule = true;
          this.getUsersDate();
        }
      }
    },
    'changeView': function () {
      this.scheduleKey += 1;
      setTimeout(() => {
        if (this.changeView === false) {
          this.loadFilteredData();
          this.clearFilters();
          this.spinnerSchedule = false;
        }
        if (this.changeView === true) {
          this.getUsersDate();
        }
      }, 200);
    },
    'scheduleKey': function () {
      setTimeout(() => {
        this.loadFilteredData();
      }, 200);
    },
    'currentDate.month': function () {
      this.firstDayInLastMonth();
      setTimeout(() => {
        this.getFirstDay();
        if (this.changeView === true && this.currentDate.month) {
          this.spinnerSchedule = true
          this.getUsersDate();
        }
      }, 100);
    }
  },
  computed: {
    userData () {
      return this.$store.getters.getAccount
    },
    hardTimeList () {
      return visitHoursList();
    },
    prevMonthDays () {
      let year = this.currentDate.month === 1 ? this.currentDate.year - 1 : this.currentDate.year;
      let month = this.currentDate.month === 1 ? 12 : this.currentDate.month;
      return new Date(year, month, 0).getDate();
    },
    firstMonthDay () {
      let firstDay = new Date(this.currentDate.year, this.currentDate.month, 1).getDate();
      if (this.dayPrev === 'poniedziałek') firstDay = 0;
      if (this.dayPrev === 'wtorek') firstDay = 1;
      if (this.dayPrev === 'środa') firstDay = 2;
      if (this.dayPrev === 'czwartek') firstDay = 3;
      if (this.dayPrev === 'piątek') firstDay = 4;
      if (this.dayPrev === 'sobota') firstDay = 5;
      if (this.dayPrev === 'niedziela') firstDay = 6;
      return firstDay;
    },
    currentMonthDays () {
      return new Date(this.currentDate.year, this.currentDate.month, 0).getDate();
    },
    prevMonth () {
      return new Date(this.currentDate.year, this.currentDate.month - 1, 0).getDate();
    },
    startDate () {
      return [this.currentDate.year, this.currentDate.month, this.currentDate.date].map(n => n < 10 ? '0' + n : n).join('-');
    },
    currentDay () {
      const now = new Date();
      return (now.getDate() + ' ' + (this.monthShort[now.getMonth()]) + ' - ' + (this.weekDayNames[now.getDay() - 1]))
    },
    dayNames () {
      return CalendarUtils.getDayNames(this.startDate, this.daysCount);
    },
  },
  methods: {
    refreshData () {
      this.componentKeyPopup += 1;
      this.getUsersDate();
      this.loadFilteredData();
    },
    getUser () {
      this.$store.dispatch('userAccountGet')
    },
    rightUsersAll () {
      const users = this.usersDate;
      const patients = this.patients;
      let arrUsers = [];
      let time = [];
      let visits = [];
      let patient = [];
      let timeObj = [];
      let timeObjFree = [];
      let dateObj = [];
      for (let j = 0; j < users.length; j++) {
        const usersVisits = users[j].visits
        arrUsers[j] = {
          name: users[j].name + ' ' + users[j].last_name,
          id: users[j].id,
          is_working: users[j].is_working,
          time: [],
          visits: [],
          free_hours: users[j].free_hours
        };
        for (let i = 0; i < usersVisits.length; i++) {
          time[i] = {
            id: usersVisits[i].user_id,
            dateStart: usersVisits[i].date_start,
            dateEnd: usersVisits[i].date_end,
          };
          visits[i] = {
            visitsId: usersVisits[i].id,
            id: usersVisits[i].user_id,
          };
          arrUsers[j].time.push(time.filter(n => n.id === users[j].id));
          arrUsers[j].visits.push(visits.filter(n => n.id === users[j].id));
          for (let l = 0; l < patients.length; l++) {
            if (usersVisits[i].patient_id === patients[l].id) {
              patient[i] = patients[l].name + ' ' + patients[l].last_name;
            }
          }
        }
        if (arrUsers[j].time) {
          timeObj = arrUsers[j].time;
          for (let z = 0; z < timeObj.length; z++) {
            dateObj[j] = timeObj[z];
          }
        }
        if (arrUsers[j].free_hours) {
          timeObjFree = arrUsers[j].free_hours;
          for (let z = 0; z < timeObjFree.length; z++) {
            this.dateAllListFree[j] = timeObjFree[z];
          }
        }
        this.dateAllList = dateObj
        this.usersAllList = arrUsers.filter(n => n);
        this.patientAllName = patient.filter(n => n);
      }
    },
    rightUsers () {
      const users = this.usersDate;
      const patients = this.patients;
      let arrUsers = [];
      let time = [];
      let visits = [];
      let patient = [];
      let timeObj = [];
      let dateObj = [];
      let dateObjFree = [];
      let timeObjFree = [];
      for (let j = 0; j < users.length; j++) {
        if (users[j].visits) {
          if (users[j].visits.length) {
            const usersVisits = users[j].visits
            arrUsers[j] = {
              name: users[j].name + ' ' + users[j].last_name,
              id: users[j].id,
              is_working: users[j].is_working,
              time: [],
              visits: [],
              free_hours: users[j].free_hours
            };
            for (let i = 0; i < usersVisits.length; i++) {
              time[i] = {
                id: usersVisits[i].user_id,
                dateStart: usersVisits[i].date_start,
                dateEnd: usersVisits[i].date_end,
              };
              visits[i] = {
                visitsId: usersVisits[i].id,
                id: usersVisits[i].user_id,
              };
              arrUsers[j].time.push(time.filter(n => n.id === users[j].id));
              arrUsers[j].visits.push(visits.filter(n => n.id === users[j].id));
              for (let l = 0; l < patients.length; l++) {
                if (usersVisits[i].patient_id === patients[l].id) {
                  patient[i] = patients[l].name + ' ' + patients[l].last_name;
                }
              }
            }
            if (arrUsers[j].time) {
              timeObj = arrUsers[j].time;
              for (let z = 0; z < timeObj.length; z++) {
                dateObj[j] = timeObj[z];
              }
            }
            if (arrUsers[j].free_hours) {
              timeObjFree = arrUsers[j].free_hours;
              for (let z = 0; z < timeObjFree.length; z++) {
                dateObjFree[j] = timeObjFree[z];
              }
            }
            this.dateListFree = dateObjFree.filter(n => n)
            this.dateList = dateObj.filter(n => n)
            this.usersList = arrUsers.filter(n => n);
            this.patientName = patient.filter(n => n);
          }
        }
      }
    },
    alertEmpty () {
      this.empty = false
    },
    getPatientsList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/patients/items',
        outputKey: 'patients',
        params: {
          pagination: false
        },
      });
    },
    getUsersDate () {
      this.usersDate = [];
      if (this.filters.institution_id !== '') {
        FormUtils.loadAdditionalData(this, {
          endpoint: '/users/items-by-date',
          outputKey: 'usersDate',
          pagination: false,
          params: {
            date: this.startDate,
            institution_id: this.filters.institution_id === '' ? 0 : this.filters.institution_id
          },
          successAction: () => {
            setTimeout(() => {
              this.rightUsers();
              this.rightUsersAll();
            }, 400)
            this.spinnerSchedule = false;
          }
        });
      }
    },
    dateUp () {
      if (this.currentDate.date === this.currentMonthDays) {
        this.currentDate.date = 1;
        this.monthUp();
      } else {
        this.currentDate.date += 1;
      }
    },
    dateDown () {
      if (this.currentDate.date === 1) {
        this.currentDate.date = this.prevMonthDays;
        this.monthDown();
      } else {
        this.currentDate.date -= 1;
      }
    },
    monthUp () {
      if (this.currentDate.month === 12) {
        this.currentDate.month = 1;
        this.currentDate.year += 1;
      } else {
        this.currentDate.month += 1;
      }
    },
    monthDown () {
      if (this.currentDate.month === 1) {
        this.currentDate.month = 12;
        this.currentDate.year -= 1;
      } else {
        this.currentDate.month -= 1;
      }
    },
    firstDayInLastMonth () {
      let month = this.monthNumber[this.currentDate.month - 1];
      let year = this.currentDate.year;
      this.firstDayPrev = (year + '-' + month + '-01')
    },
    getFirstDay () {
      this.dayPrev = new Date(this.firstDayPrev.toString()).toLocaleDateString(undefined, { weekday: 'long' });
    },
    checkTheMonthNumber () {
      if ((this.currentDate.date === 1) || (this.currentDate.date === 2) ||
        (this.currentDate.date === 3) || (this.currentDate.date === 4) ||
        (this.currentDate.date === 5) || (this.currentDate.date === 6) ||
        (this.currentDate.date === 7) || (this.currentDate.date === 9)) {
        this.currentDateCopyDate = '0' + this.currentDate.date
      } else {
        this.currentDateCopyDate = this.currentDate.date
      }
    },
    checkSundays () {
      this.day = new Date(this.currentDate.year + '-' + this.monthNumber[this.currentDate.month - 1] + '-' + this.currentDateCopyDate).toLocaleDateString(undefined, { weekday: 'long' });
    },
    getCurrentDate () {
      let today = new Date();
      this.currentDate.date = today.getDate();
      this.currentDate.month = today.getMonth() + 1;
      this.currentDate.year = today.getFullYear() + this.currentDate.yearAdd;
    },
    showModalAdd (doc) {
      this.showModal = !this.showModal;
      this.modalAdd = doc
    },
    handleClose() {
      this.showModal = false
    },
    buttonChangeView() {
      this.changeView = !this.changeView;
      this.spinnerSchedule = true
    },
    showModalInfo (visit) {
      this.showModalVisit = !this.showModalVisit;
      this.visit = visit
    },
    handleCloseInfo() {
      this.showModalVisit = false
    },
    refreshList() {
      this.loadFilteredData();
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
      if (this.changeView) {
        setTimeout(() => {
          this.rightUsersAll();
          this.rightUsers();
        }, 800)
      }
    }, 250),
    loadFilteredData () {
      ListUtils.loadItemsData(this, {
        endpoint: '/visits/list',
        listField: 'visits',
        pagination: false,
        params: {
          pagination: false,
          date_start: this.startDate,
          date_end: this.startDate,
          user_id: this.filters.user_id,
          institution_id: this.filters.institution_id,
          service_id: this.filters.service_id,
          search: this.filters.search
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        search: '',
        user_id: '',
        institution_id: '',
        service_id: ''
      };
      this.selectKeyInstitutionsFalse += 1;
      this.selectKeyInstitutionsTrue += 1;
      this.selectKeyServices += 1;
      this.loadFilteredData();
      if (this.changeView) {
        setTimeout(() => {
          this.rightUsersAll();
          this.rightUsers();
        }, 800)
      }
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['visits-filters-form'], this.debouncedLoadFilteredData);
    },
    removeVisit (visitID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/visits/delete/',
        id: visitID,
        successTitle: 'Usunięto wizytę',
        successText: 'Wybrana wizyta została usunięta',
        confirmTitle: 'Czy na pewno chcesz usunąć tą wizytę?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie wizyty nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    cancelVisit (visitID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/visits/cancel/',
        id: visitID,
        successTitle: 'Anulowano wizytę',
        successText: 'Wybrana wizyta została anulowana',
        confirmTitle: 'Czy na pewno chcesz anulować tą wizytę?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Anulowanie wizyty nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
  @import '../../assets/scss/visits-list.scss';
  @import '../../assets/scss/visits-calendar.scss';
</style>
